// extracted by mini-css-extract-plugin
module.exports = {"divIcon":"location-marker_divIcon__x9X20","smoothTransition":"location-marker_smoothTransition__giIgC","marker":"location-marker_marker__n9YTS"};